import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 197.83 129.28' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='general_content' data-name='general content'>
        <path
          className='cls-1'
          d='M19.37 57.62A9.37 9.37 0 0 1 21.29 70a7.8 7.8 0 0 1-6.48 3.66V77a11.12 11.12 0 0 0 9.27-5.18A12.76 12.76 0 0 0 21.4 55a10.73 10.73 0 0 0-6.59-2.27V56a7.42 7.42 0 0 1 4.56 1.62z'
        />
        <path
          className='cls-1'
          d='M197.83 122.61V0H0v129.28h197.83zm-6.67-37.23v15.46h-27.64V85.38zm0-37.72V82h-27.64V47.66zm-31 0V82h-8.92V47.66zm-12.24 30.66A11.52 11.52 0 0 1 142.3 76c-5.59-4.29-6.91-12.73-2.94-18.82a12.12 12.12 0 0 1 8.56-5.53zm43.23-49.87v15.88h-27.63V28.45zm0-3.34h-31v19.22h-12.23v4a15.39 15.39 0 0 0-11.35 7 17.56 17.56 0 0 0-2.81 9.6 17.21 17.21 0 0 0 6.51 13.68 14.83 14.83 0 0 0 7.65 3v3.68h12.26v18.79h31v9.61h-14.35a42.31 42.31 0 0 1-26.53-9c-20.38-15.66-25.22-46.42-10.78-68.58 8.56-13.12 22.5-20.86 37.32-20.69h14.32zM6.67 43.9V28.45h27.74V43.9zm0 37.72V47.24h27.74v34.38zm31.08 0V47.24h8.85v34.38zM49.94 51a11.5 11.5 0 0 1 5.62 2.32c5.59 4.25 6.9 12.68 2.94 18.77a12.13 12.13 0 0 1-8.56 5.53zM6.67 100.83V85h27.74v15.88zm0 3.34h31.08V85h12.19v-4a15.4 15.4 0 0 0 11.35-7c4.9-7.51 3.24-18-3.7-23.28a14.82 14.82 0 0 0-7.65-3V43.9H37.75V25.11H6.67V15.5H21a42.3 42.3 0 0 1 26.53 9c20.42 15.66 25.26 46.42 10.81 68.57-8.56 13.12-22.5 20.86-37.32 20.7H6.67zm0 18.44v-5.5H21c16 .17 31-8.11 40.14-22.22 15.37-23.57 10.19-56.34-11.54-73A45.59 45.59 0 0 0 21 12.17H6.67v-5.5h90.58v115.94zm93.91 0V6.67h90.58v5.49h-14.3c-15.95-.18-30.95 8.13-40.13 22.21a55.19 55.19 0 0 0-8.84 30.17c0 16.45 7.1 32.66 20.39 42.87a45.59 45.59 0 0 0 28.58 9.68h14.31v5.49z'
        />
        <path
          className='cls-1'
          d='M178.49 71.67a9.37 9.37 0 0 1-1.92-12.36 7.8 7.8 0 0 1 6.43-3.66v-3.34a11.12 11.12 0 0 0-9.27 5.18 12.66 12.66 0 0 0-2 6.93 12.45 12.45 0 0 0 4.71 9.89 10.73 10.73 0 0 0 6.56 2.27v-3.34a7.41 7.41 0 0 1-4.51-1.57z'
        />
        <text
          transform='translate(75.28 98.26)'
          fontSize={90.73}
          fill='#4d4d4d'
          fontFamily='Barlow-Bold,Barlow'
          fontWeight={700}
        >
          ?
        </text>
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/404Icon.js